import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"
import _imports_0 from '../../assets/image/sjx.png'


const _hoisted_1 = { class: "diy-options" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "icon" }
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = { class: "title" }
const _hoisted_6 = { class: "placeholder" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1)

import { ref, onMounted, onUnmounted, Ref, watch } from "vue";
import request from "@/utils/request";
import { store } from "@/store"
import { useRouter, useRoute } from 'vue-router'
interface categoryOptions {
  value: string | number;
  label?: any;
  disabled?: boolean;
  children?: [];
}

export default /*#__PURE__*/_defineComponent({
  props: ['modelValue'],
  setup(__props, { emit }) {

const { modelValue = '' } = __props
const tooltipVisible: Ref<boolean> = ref(false);
const router = useRouter()
const route = useRoute()


const categoryOptions = ref<any>([
  {
    id: '',
    icon: 'https://pubimg-wfile.xiangsusheji.com/2024/04/05/22/e882e016-fcc7-4967-80ab-85bfa95e86bf.png',
    name: '所有素材'
  }
])

const valueName = ref<any>('')
request.get("/item/getItemCategoryList").then(res => {
  if (res && res.code === 200) {
    store.commit("setCategory", res.result)
    categoryOptions.value.push(...res.result)
    if (route.query.pid) {
      store.commit("setCategoryType", {
        value: route.query.pid,
        name: getTopTypeName(route.query.pid)
      })
      valueName.value = getTopTypeName(route.query.pid)
    } else {
      store.commit("setCategoryType", {
        value: '',
        name: '所有素材'
      })
    }
  }
})
watch(
  () => route.query,
  (newParams, oldParams) => {
    if (newParams.pid) {
      store.commit("setCategoryType", {
        value: newParams.pid,
        name: getTopTypeName(newParams.pid)
      })
    }
  },
  {
    deep: true, // 深度监听
    flush: 'post' // 在侦听器回调中访问被 Vue 更新之后的 DOM
  },
);
// 获取选中的一级分类名称
const getTopTypeName = (id: any) => {
  if (!id) return ''
  return categoryOptions.value.filter((row: any) => {
    return row.id == id
  })[0]?.name
}

const change = (row: any) => {
  valueName.value = row.name
  tooltipVisible.value = false
  router.push({
    path: '/filtering',
    query: {
      ...route.query,
      id: '',
      pid: row.id
    }
  })
  store.commit("setCategoryType", {
    value: row.id,
    name: row.name
  })
  emit('update:modelValue', row.id);
}
// const doScroll = () => {
//   tooltipVisible.value = false
// }
// onMounted(() => {
//   window.addEventListener('scroll', doScroll)
// })

// onUnmounted(() => {
//   window.removeEventListener('scroll', doScroll)
// }) 

return (_ctx: any,_cache: any) => {
  const _component_a_tooltip = _resolveComponent("a-tooltip")!

  return (_openBlock(), _createBlock(_component_a_tooltip, {
    placement: "bottomLeft",
    visible: tooltipVisible.value,
    "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => (tooltipVisible.value = $event)),
    trigger: "click",
    color: "#fff",
    overlayClassName: "diy-select",
    getPopupContainer: (trigger) => trigger.parentNode
  }, {
    title: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categoryOptions.value, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "item",
            onClick: ($event: any) => (change(item))
          }, [
            _createElementVNode("div", _hoisted_3, [
              _withDirectives(_createElementVNode("img", {
                style: {"width":"24px"},
                src: item.icon,
                alt: item.name
              }, null, 8, _hoisted_4), [
                [_vShow, item.icon]
              ])
            ]),
            _createElementVNode("div", _hoisted_5, _toDisplayString(item.name), 1)
          ], 8, _hoisted_2))
        }), 256))
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("span", null, _toDisplayString(_unref(store).state.categoryType.name || valueName.value || '所有素材'), 1),
        _hoisted_7
      ])
    ]),
    _: 1
  }, 8, ["visible", "getPopupContainer"]))
}
}

})